import { combineReducers } from "@reduxjs/toolkit";
import brandTemplatesReducer, { BrandTemplatesState } from "./brandTemplates";
import hostedPagesReducer, { BrandsState, CurrentBrandSlice, CurrentBrandState } from "./hostedpages";
import pagesReducer, { PagesState } from "./pages";
import sdkVersionsReducer, { SdkVersionsState } from "./sdkVersions";
const rootReducer = combineReducers({
  Brands: hostedPagesReducer,
  CurrentBrand: CurrentBrandSlice.reducer,
  Pages: pagesReducer,
  SdkVersions: sdkVersionsReducer,
  BrandTemplates: brandTemplatesReducer
});

export default rootReducer;

export interface NewHostedPagesSchema {
  Brands: BrandsState;
  CurrentBrand: CurrentBrandState;
  Pages: PagesState;
  SdkVersions: SdkVersionsState;
  BrandTemplates: BrandTemplatesState;
}
